<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isPortalDomain, isProduction } from '@/config/domainConfig'

export default {
  name: 'App',
  mounted() {
    // Initialiser la configuration selon le domaine
    this.initializeDomainConfig();
  },
  methods: {
    initializeDomainConfig() {
      // Stocker la configuration dans le store pour l'utiliser dans l'application
      const domainConfig = this.$store.getters['config/domainConfig'];
      if (!domainConfig) {
        this.$store.commit('config/setDomainConfig', {
          isPortal: this.isPortalDomain,
          isProduction: this.isProduction,
          apiConfig: this.getApiConfig()
        });
      }
    },
    getApiConfig() {
      if (this.isPortalDomain && this.isProduction) {
        return {
          baseURL: 'https://api.padmar-performance.org/api/',
          baseURLFile: 'https://api.padmar-performance.org/',
          title: 'Portail PADMAR-E',
          description: 'Portail public de suivi du PADMAR-E'
        };
      } else {
        return {
          baseURL: process.env.VUE_APP_BASE_URL || 'http://localhost:8000/api/',
          baseURLFile: process.env.VUE_APP_BASE_URL_FILE || 'http://localhost:8000/',
          title: 'Administration PADMAR-E',
          description: 'Interface d\'administration du PADMAR-E'
        };
      }
    }
  },
  computed: {
    isPortalDomain() {
      return isPortalDomain();
    },
    isProduction() {
      return isProduction();
    }
  }
}
</script>

<style>
#app {
  font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
